import { render, staticRenderFns } from "./StorageYN.vue?vue&type=template&id=2f88464b"
import script from "./StorageYN.vue?vue&type=script&lang=js"
export * from "./StorageYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports